import MyProfilePage from './MyProfilePage';

export default MyProfilePage;